/* Portal — resultado del checkout (a donde vuelve MercadoPago dentro del portal). */
import { Link, useSearchParams } from 'react-router-dom'

const CONFIG: Record<string, { title: string; msg: string; color: string; bg: string }> = {
  exitoso: { title: '¡Pago confirmado!', msg: 'Tu pago se procesó correctamente. Estamos activando tu servicio; lo verás en "Mi Hosting" en unos minutos.', color: 'var(--success)', bg: 'color-mix(in srgb, var(--success) 12%, transparent)' },
  pendiente: { title: 'Pago en proceso', msg: 'Tu pago está siendo procesado. Te avisaremos por correo cuando se confirme.', color: 'var(--warning)', bg: 'color-mix(in srgb, var(--warning) 12%, transparent)' },
  fallido: { title: 'Pago no completado', msg: 'No pudimos procesar tu pago. Puedes intentarlo de nuevo o escribirnos por soporte.', color: 'var(--danger)', bg: 'color-mix(in srgb, var(--danger) 12%, transparent)' },
}

export default function PortalCheckoutGracias() {
  const [sp] = useSearchParams()
  const codigo = sp.get('codigo') || ''
  const cfg = CONFIG[sp.get('estado') || 'exitoso'] || CONFIG.exitoso

  return (
    <div className="portal-page-enter" style={{ padding: '2rem', maxWidth: 520 }}>
      <div style={{ width: 56, height: 56, borderRadius: '50%', background: cfg.bg, color: cfg.color, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 18 }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
      </div>
      <span className="portal-saludo">{cfg.title}</span>
      <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginTop: 8 }}>{cfg.msg}</p>
      {codigo && <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', marginTop: 8 }}>Código de pedido: <strong>{codigo}</strong></p>}
      <div style={{ display: 'flex', gap: 10, marginTop: 24, flexWrap: 'wrap' }}>
        <Link to="/portal/hosting" className="btn btn-primary">Ir a Mi Hosting</Link>
        <Link to="/portal" className="btn btn-secondary">Volver al resumen</Link>
      </div>
    </div>
  )
}
